interface SearchMagnifyingGlassIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}

export function SearchMagnifyingGlassIcon({
  color = 'currentColor',
  ...svgProps
}: SearchMagnifyingGlassIconProps) {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M10.25 10.5L13.25 13.25M7.5 11.5C9.70914 11.5 11.5 9.70914 11.5 7.5C11.5 5.29086 9.70914 3.5 7.5 3.5C5.29086 3.5 3.5 5.29086 3.5 7.5C3.5 9.70914 5.29086 11.5 7.5 11.5Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

/**
 * Alternative magnifying glass icon which is designed for readability at smaller sizes, like in search inputs.
 */
export const SmallSearchMagnifyingGlassIcon = ({
  color,
  ...svgProps
}: SearchMagnifyingGlassIconProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 32 32" {...svgProps}>
    <g
      fill="none"
      fillRule="evenodd"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
    >
      <circle cx="14" cy="14" r="8" />
      <path d="M19.5 19.5l6 6" />
    </g>
  </svg>
);
